import { useEffect, useState } from "react";

/** How long a search box waits after the last keystroke before it queries. */
export const SEARCH_DEBOUNCE_MS = 300;

/**
 * The value as it was `delayMs` after its last change. Each keystroke in a
 * search box is a new query key, so the tabs pass the debounced text to their
 * read hooks instead of the raw one.
 */
export function useDebouncedValue<TValue>(
  value: TValue,
  delayMs: number = SEARCH_DEBOUNCE_MS
): TValue {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debouncedValue;
}
